export class HorseModel {
  id: number;
  code: string;
  num: number;
  name: string;
  draw: number;
  hotLevel: number;
  jockeyName: string;
  trainerName: string;
  scratched: boolean;
  wpSelected: boolean;
  qqpBankerSelected: boolean;
  qqpSelSelected: boolean;
  noteCreated: boolean;
  noteCreatedBefore: boolean;
  finishingOrder: number;
  winOdd: number;
  placeOdd: number;
  winFavourite: boolean;
  placeFavourite: boolean;

  constructor(id: number, code: string, num: number, name: string, draw: number, hotLevel: number,
    jockeyName: string, trainerName: string, scratched: boolean, wpSelected: boolean = false, qqpBankerSelected: boolean = false,
    qqpSelSelected: boolean = false, noteCreated = false, noteCreatedBefore = false, finishingOrder: number = -1, winOdd: number = 0, 
    placeOdd: number = 0, winFavourite: boolean = false, placeFavourite: boolean = false) {
    this.id = id;
    this.code = code;
    this.num = num;
    this.name = name;
    this.draw = draw;
    this.hotLevel = hotLevel;
    this.jockeyName = jockeyName;
    this.trainerName = trainerName;
    this.scratched = scratched;
    this.wpSelected = wpSelected;
    this.qqpBankerSelected = qqpBankerSelected;
    this.qqpSelSelected = qqpSelSelected;
    this.noteCreated = noteCreated;
    this.noteCreatedBefore = noteCreatedBefore;
    this.finishingOrder = finishingOrder
    this.winOdd = winOdd
    this.placeOdd = placeOdd;
    this.winFavourite = winFavourite;
    this.placeFavourite = placeFavourite;
  }

  copy(horseFrom: HorseModel) {
    if (horseFrom == null) return;
    this.id = horseFrom.id;
    this.code = horseFrom.code;
    this.num = horseFrom.num;
    this.name = horseFrom.name;
    this.draw = horseFrom.draw;
    this.hotLevel = horseFrom.hotLevel;
    this.jockeyName = horseFrom.jockeyName;
    this.trainerName = horseFrom.trainerName;
    this.scratched =horseFrom.scratched;
    this.wpSelected = horseFrom.wpSelected;
    this.qqpBankerSelected = horseFrom.qqpBankerSelected;
    this.qqpSelSelected = horseFrom.qqpSelSelected;
    this.noteCreated = horseFrom.noteCreated;
    this.noteCreatedBefore = horseFrom.noteCreatedBefore;
    this.finishingOrder = horseFrom.finishingOrder
    this.winOdd = horseFrom.winOdd
    this.placeOdd = horseFrom.placeOdd;
    this.winFavourite = horseFrom.winFavourite;
    this.placeFavourite = horseFrom.placeFavourite;
  }

}



// WEBPACK FOOTER //
// ./src/model/horse/HorseModel.ts